import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const CompanionTabWrapper = ({
  children
}) => {
  return /*#__PURE__*/_jsx(View, {
    borderColor: "border-core-subtle",
    borderRadius: "300",
    borderStyle: "solid",
    borderWidth: "100",
    children: children
  });
};
export default CompanionTabWrapper;